exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".adit-title[data-v-906acc72]{margin-top:30px;font-weight:700;font-size:1.3rem;color:#555}", ""]);

